import React from 'react'
import { Modal } from '../../_EOS/Modal'

interface BreakStockModalProps {
  isOpen: boolean
  onClose: () => void
}

export const BreakStockModal: React.FC<BreakStockModalProps> = ({
  isOpen,
  onClose
}) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h3 style={{ color: 'red' }}>Hay quiebre de stock en este SKU</h3>
        <button
          onClick={onClose}
          style={{
            marginTop: '20px',
            padding: '10px 20px',
            backgroundColor: '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Aceptar
        </button>
      </div>
    </Modal>
  )
} 